function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.625,
    height: 32,
    viewBox: "0 0 30.625 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 1087",
    cx: 15.313,
    cy: 16,
    rx: 15.313,
    ry: 16,
    style: {
      fill: "#e88102"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1088",
    cx: 15.156,
    cy: 15.156,
    r: 15.156,
    transform: "translate(.156)",
    style: {
      fill: "#fdd835"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58282",
    d: "m35.362 1.819-19.95 19.944a15 15 0 0 1-1.212-4.938L30.419.6a15.234 15.234 0 0 1 4.944 1.219z",
    transform: "translate(-14 -.563)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58283",
    d: "M105.613 71.469 84.969 92.113a15.131 15.131 0 0 1-3.469-2.688L102.931 68a15.144 15.144 0 0 1 2.682 3.469z",
    transform: "translate(-77.094 -63.75)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58284",
    d: "M79.719 44.744 58.344 66.119c-.331-.387-.65-.794-.944-1.213L78.506 43.8c.419.294.825.612 1.213.944z",
    transform: "translate(-54.5 -41.062)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58285",
    d: "m189.494 157.531-18.462 18.462a15.974 15.974 0 0 1-1.631-.519l19.574-19.574a15.974 15.974 0 0 1 .519 1.631z",
    transform: "translate(-159.5 -146.156)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58286",
    d: "M43.813 15.156c0 .106 0 .206-.006.313a15.153 15.153 0 0 0-30.3 0c0-.106-.006-.206-.006-.312a15.156 15.156 0 0 1 30.313 0z",
    transform: "translate(-13.344)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58287",
    d: "M137.531 132.063a11.875 11.875 0 0 1-21.031 7.563A11.875 11.875 0 0 0 134.375 124a11.848 11.848 0 0 1 3.156 8.063z",
    transform: "translate(-109.907 -116.25)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.438 3.438)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1089",
    cx: 11.875,
    cy: 11.875,
    r: 11.875,
    style: {
      fill: "#f39e09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58288",
    d: "M86.875 59.125a11.877 11.877 0 0 0-16.75 16.75 11.877 11.877 0 1 1 16.75-16.75z",
    transform: "translate(-66 -55)",
    style: {
      fill: "#e88102"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58289",
    d: "M174.362 117.938V117l-1.088.938h-9.819l-.744 2.2v.938h3.119a2.06 2.06 0 0 1 1.994 1.15h-4.488l-.637 1.506v.938h5.212a2.083 2.083 0 0 1-2.144 1.55h-2.738l.012 2.238 5.325 6.356h4.356v-.937l-.775-.187-3.931-4.819a6.179 6.179 0 0 0 2.75-1.562 4.911 4.911 0 0 0 1.237-2.631h1.706l.637-2.444v-.937l-.9.938h-1.419a4.688 4.688 0 0 0-.663-1.844h2.35z",
    transform: "translate(-153.219 -109.687)",
    style: {
      fill: "#db6704"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58290",
    d: "M173.913 119.444h-2.35a4.788 4.788 0 0 1 .663 1.844h2.319l-.637 2.444H172.2a4.866 4.866 0 0 1-1.238 2.631 6.179 6.179 0 0 1-2.75 1.563l4.706 5.775v.175h-4.356l-5.319-6.35-.012-2.238h2.738a2.088 2.088 0 0 0 2.144-1.556H162.9l.638-2.444h4.487a2.063 2.063 0 0 0-1.994-1.15h-3.119l.744-3.137h10.906z",
    transform: "translate(-153.407 -109.687)",
    style: {
      fill: "#fdd835"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58291",
    d: "M168.212 185.6h.894l-1.206 1.206z",
    transform: "translate(-158.094 -174)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58292",
    d: "m168.706 117-3.137 3.137H162.9l.744-3.137z",
    transform: "translate(-153.407 -109.687)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58293",
    d: "M336.381 152.538h-.181l.244-.238z",
    transform: "translate(-315.876 -142.781)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58294",
    d: "m196.1 181.288-.638 2.444h-1.706a4.823 4.823 0 0 1-1.238 2.631 6.18 6.18 0 0 1-2.75 1.563l1.438 1.756-2.5 2.5-2.806-3.35 7.831-7.832c.019.094.038.188.05.281z",
    transform: "translate(-174.969 -169.687)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58295",
    d: "M170.931 247.163a2.692 2.692 0 0 0 .906-.163l-3.069 3.069-.562-.669-.006-.919 1.319-1.319z",
    transform: "translate(-158.375 -231.562)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58296",
    d: "m222.644 117-.156.6-1.844 1.844h-.988a4.062 4.062 0 0 1 .337.656l-3.881 3.881c.031-.075.063-.162.087-.244h-2l6.732-6.737z",
    transform: "translate(-201.5 -109.687)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58297",
    d: "m255.944 347.387-1.356 1.362h-2.031l-.056-.069 2.481-2.481z",
    transform: "translate(-237.407 -324.562)",
    style: {
      opacity: 0.5,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58298",
    d: "M106.531 79.069a28.387 28.387 0 0 0-16.887 16.162 11.985 11.985 0 0 1-.769-.612 11.873 11.873 0 0 1 16.744-16.744 12.831 12.831 0 0 1 .912 1.194z",
    transform: "translate(-81.313 -70.312)",
    style: {
      opacity: 0.25,
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyIcon);
export default __webpack_public_path__ + "static/media/CurrencyIcon.130fa5beb205fdd2af5bce87cd233056.svg";
export { ForwardRef as ReactComponent };